import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdateBlogCategory($data: UpdateBlogCategoryInput!) {
    updateBlogCategory(data: $data) {
      id
    }
  }
`);

export interface UpdateGql {
  updateBlogCategory: {
    id: number;
  };
}
